import { StyleSheet } from '@react-pdf/renderer';
const textSize = 10;
const boldSize = "Helvetica-Bold"
const blue = "#39a1d2";

const styles = StyleSheet.create({
    page: {
        padding: 30,
        paddingBottom: 60,
        fontFamily: "Helvetica",
        textAlign: "justify",
        display: "flex",
        justifyContent: "space-between"
    },
    betweenParagraphe: {
        marginTop: 10,
    },
    capitalize: {
        textTransform: "capitalize",
    },
    faita: {
        textAlign: "center"
    },
    dateView : {
        fontSize : "10px",
        display: "flex",
        flexDirection : 'column',
    },
    enteteCadrant : {
        border :"2px solid " + blue,
        display: "flex",
        justifyContent: "center",
        textAlign: "left",
        fontSize: "12px",
        padding: '2px',
        backgroundColor : blue,
        color : '#FFFFFF'
    },
    enteteDiv : {
        borderRight :"2px solid " + blue,
        borderLeft :"2px solid " + blue,
        borderBottom :"2px solid " + blue,
        display: "flex",
        justifyContent: "center",
        // textAlign: "center",
        fontSize: "12px",
        padding: '2px',
        marginTop: '-1px',
        backgroundColor : blue,
        color: "#FFFFFF"
    },
    responseEncadrant : {
        borderRight :"2px solid " + blue,
        borderLeft :"2px solid " + blue,
        borderBottom :"2px solid " + blue,
        display: "flex",
        justifyContent: "center",
        textAlign: "left",
        fontSize: "10px",
        padding: '2px',
        marginTop: '-1px'
    },
    title: {
        textAlign: "center",
        fontFamily: boldSize
    },
    caseCoche : {
        height: '10px',
        width: '10px',
    },
    travaux: {
        border: "2px solid #000000",
        paddingTop: 3,
        paddingLeft: 3,
        borderRadius: "50%",
        marginTop: "-3"
    },
    sousigne: {
        marginTop: 20,
        fontSize: textSize
    },
    decalage: {
        marginTop: 10,
        marginLeft: 10
    },
    signatures: {
        fontSize: '10px',
        marginTop: '7px',
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        height : '100px'
    },
    evidence: {
        fontFamily: boldSize
    },
    decalageHaut: {
        marginTop: 10
    },
    preambule: {
        marginTop: 20,
        fontSize: 10,
        marginLeft: 10,
    },
    titlePart: {
        fontFamily: boldSize,
        textDecoration: "underline"
    },
    content: {
        marginLeft: 10,
        marginTop: 5,
        lineHeight: 1.5
    },
    pageNumber: {
        position: "absolute",
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: "center",
    },
    header: {
        display: "flex",
        // height: '100px',
        flexDirection: "row",
        alignItems:"flex-start"
    },
    headerLeft: {
        color: "#000000",
        display: 'flex',
        flexBasis: '72.00%',
        flexDirection: "column"
    },
    headerRight: {
        color: "#000000",
        display: 'flex',
        flexBasis: '28.00%',
        justifyContent: "center",
        padding: '10px'
    },
    headerInfo: {
        display: "flex",
        flexDirection: 'column',
        justifyContent: "center",
    },
    headerTitle: {
        fontWeight: "light",
        fontSize: '10px',
        marginBottom: '3px'
    },
    headerWeb: {
        fontFamily: boldSize,
        fontSize: '12px',
        marginBottom: '5px'
    },
    headerAdresse: {
        fontSize: '8px',
        marginBottom: '5px'
    },
    headerContact: {
        fontSize: '8px'
    },
    placeChantier : {
        marginTop : '3px',
    },
    headerIntervention: {
        fontSize: '10px',
    },

    information: {
        marginTop: '20px',
        display: "flex",
        flexDirection: "row",
        fontSize: '12px'
    },
    informationClient: {

    },
    informationContact: {
        marginTop:-40
    },
    titleUnderLine : {
        textDecoration : "underline"
    },
    informationLieu: {
        height: '67px',
        fontSize: "10px",
        marginTop: "5px"
    },
    informationLeft: {
        color: "#000000",
        // display: 'flex',
        // justifyContent: 'flex-start !important',
        flexBasis: '45.00%',
    },
    informationSpace: {
        display: 'flex',
        justifyContent: 'center',
        flexBasis: '10.00%',
        borderRight: '2px solid #000000',
        height: '100px',
    },
    informationRight: {
        marginLeft:'4px',
        display: 'flex',
        flexBasis: '45.00%',
    },
    informationAdresse: {
        marginTop: '7px',
        height: '70px',
        fontSize: "10px"
    },
    infoClient : {
        marginTop: '7px',
        fontSize: "10px"
    },
    informationInterlocuteur: {
        display: "flex",
        justifyContent: "flex-end",
        fontSize: "10px",
        marginTop: -40
    },
    imputation: {
        display: "flex",
        flexDirection: "row",
        borderRight: '2px solid ' + blue,
        borderBottom: '2px solid ' + blue,
        borderLeft: '2px solid ' + blue,
        fontSize: '10px',
        marginTop: "-1px"
    },
    imputationLeft: {
        padding: '2px',
        color: "#000000",
        display: 'flex',
        flexBasis: '70.00%',
        flexDirection: "row"
    },
    imputationRight: {
        color: "#000000",
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: "row",
        flexBasis: '30.00%',
        borderLeft: '2px solid ' +blue,
        padding: '5px'
    },
    blocQuestionReponse: {
        marginTop: '10px'
    },
    question: {
        fontSize: '10px',
        fontFamily: boldSize,
    },
    response: {
        display: "flex",
        flexDirection: 'column',
        marginTop: '2px',
        fontSize: '9px',
        marginLeft: '2px'
    },
    footer: {
        // marginTop: '5px',
        // fontSize: '9px',
        display: "flex",
        flexDirection: "row",
    },
    hauteurMax: {
        maxHeight: 50,
        fontSize: "7px"
    },
    hauteurMaxDesc: {
        maxHeight: 100,
        paddingHorizontal: "5px",
        fontSize: "7px"
    },
    entete: {
        display: "flex",
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: "center",
        borderCollapse: "collapse",
    },
    dateCase: {
        padding: '5px',
        height: '30px',
        borderRight: "0.5px solid #000000",
        borderLeft: "1px solid #000000",
        borderBottom: "1px solid #000000",
        borderTop: "1px solid #000000",
        alignItems: "center",
        flexBasis: '30.00%',
        borderCollapse: "collapse",
    },
    dateCaseClean: {
        padding: '5px',
        borderRight: "0.5px solid #000000",
        borderLeft: "1px solid #000000",
        alignItems: "center",
        flexBasis: '30.00%',
        borderCollapse: "collapse",
    },
    tempsPasseCase: {
        padding: '5px',
        height: '30px',
        borderRight: "0.5px solid #000000",
        borderLeft: "0.5px solid #000000",
        borderBottom: "1px solid #000000",
        borderTop: "1px solid #000000",
        alignItems: "center",
        flexBasis: '30.00%',
        borderCollapse: "collapse",
    },
    tempsPasseCaseClean: {
        padding: '5px',
        borderRight: "0.5px solid #000000",
        borderLeft: "0.5px solid #000000",
        alignItems: "center",
        flexBasis: '30.00%',
        borderCollapse: "collapse",
    },
    tempsPasseCaseCleanRight: {
        padding: '5px',
        borderLeft: "0.5px solid #000000",
        alignItems: "center",
        flexBasis: '30.00%',
        borderCollapse: "collapse",
    },
    nombreHeureCase: {
        padding: '5px',
        height: '30px',
        alignItems: "center",
        flexBasis: '12.00%',
        borderRight: "1px solid #000000",
        borderLeft: "0.5px solid #000000",
        borderBottom: "1px solid #000000",
        borderTop: "1px solid #000000",
        borderCollapse: "collapse",
    },
    nombreHeureCaseClean: {
        padding: '5px',
        alignItems: "center",
        flexBasis: '12.00%',
        borderLeft: "1px solid #000000",
        borderRight: "0.5px solid #000000",
        borderCollapse: "collapse",
    },
    dayCase: {
        flexBasis: '10.00%',
        borderRight: "0.5px solid #000000",
        padding: '4px',
        alignItems: "center",
        borderCollapse: "collapse",
    },
    dayCaseClean: {
        flexBasis: '10.00%',
        borderCollapse: "collapse",
    },
    ligneTableau: {
        borderCollapse: "collapse",
        border: "1px solid #000000",
        display: "flex",
        flexDirection: 'row',
        flexBasis: '3.00%',
    },
    footerMiddle: {
        border: "2px solid #000000",
        flexBasis: '30.00%',
        marginLeft: "2px",
        marginRight: "5px"
    },
    footerEffectuer: {
        padding: '2px',
        borderBottom: "2px solid #000000",
        alignItems: "center",
        textAlign: "center"
    },
    footerDCT: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        borderBottom: "2px solid #000000",
    },
    footerDescriptif: {
        padding: '2px'
    },
    footerDate: {
        flexBasis: '3%'
    },
    footerNomPrenom: {
        flexBasis: '7%'
    },
    footerRight: {
        display: "flex",
        justifyContent: "space-around"
    },
    signatureFooter: {
        display: 'flex',
        flexBasis: '50.00%',
        flexDirection: "column"
    },
    conditions: {
        marginBottom: -50,
        fontSize: '6px',
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    image: {
        height: 'auto',
        width: '70%',
        marginBottom: '15px'
    },
    contentImages: {
        marginTop: '20px',
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }
});

export default styles